// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__a0uqz","rootCenter":"LoadMoreObserver_rootCenter__3iULb","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__2V9i3"};